import "../index.css";
import { useState, useEffect } from "react";
//import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AccessVerification } from "../auth/UserProfile";
import ApiCall from "../auth/ApiCall";
import { useSportsMetadata } from "../apiCalls/GetSportsMetadata";
import { useRule } from "../apiCalls/GetRule";
import { PageNav } from "../components/PageNav";
import Footer from "../components/Footer";
import WatcherFormStep from "../components/WatcherFormStep";
import WatcherFormNameAndSport from "../components/WatcherFormNameAndSport";
import CheckboxTree from "../components/WatcherFormTeams";
import WatcherFormSportbooks from "../components/WatcherFormSportbooks";
import WatcherFormRule from "../components/WatcherFormRule";
import WatcherFormNotifications, {
  type Notifications,
} from "../components/WatcherFormNotifications";
import WatcherFormSubmitted from "../components/WatcherFormSubmitted";
//import { type RuleType, RuleTypes } from "../types/ruleTypes";
// import ApiCall from "../auth/ApiCall";
// interface RuleResponse {
//   rule?: {
//     name?: string;
//     teams?: string[];
//     houses?: string[];
//     rule_details?: Record<string, unknown>;
//     notifications?: Record<string, unknown>;
//     sport?: number;
//   };
//   error?: string;
// }

export default function CreateRuleScreen() {
  const { ruleId } = useParams<{ ruleId: string }>();
  const navigate = useNavigate();
  const { sportsMetadata, isSportsLoading, sportsError } = useSportsMetadata();
  const [formState, setFormState] = useState<number>(1);
  const [isAtLimit, setIsAtLimit] = useState<boolean>(false);
  // const [sportSelection, setSportSelection] = useState("default");
  const [sportSelectionId, setSportSelectionId] = useState<number>(-1);
  //const [ruleType, setRuleType] = useState<RuleType>(RuleTypes.GAME);
  const [ruleTypeId, setRuleTypeId] = useState<number>(1);
  const [ruleName, setRuleName] = useState<string>("");
  const [teams, setTeams] = useState<string[]>([]);
  const [books, setBooks] = useState<string[]>([]);
  const [rule, setRule] = useState({});
  const [notifications, setNotifications] = useState<Notifications>({});
  const inEditMode = ruleId !== null && ruleId !== undefined;
  const rule_id = inEditMode ? ruleId : "";
  const { ruleData, isRuleLoading, ruleError } = useRule(rule_id);

  useEffect(() => {
    if (ruleData && ruleData.rule && !isRuleLoading && inEditMode) {
      setRuleName(ruleData.rule.name || "");
      setTeams(ruleData.rule.teams || []);
      setBooks(ruleData.rule.houses || []);
      setRule(ruleData.rule.rule_details || {});
      setNotifications((ruleData.rule.notifications as Notifications) || {});
      setSportSelectionId(ruleData.rule.sport ?? -1);
      setRuleTypeId(ruleData.rule.type ?? 1);
    }
  }, [ruleData, isRuleLoading, inEditMode]);

  // Clear form when switching to create mode (when ruleId becomes undefined)
  useEffect(() => {
    if (!inEditMode) {
      setFormState(1);
      setSportSelectionId(-1);
      setRuleTypeId(1);
      setRuleName("");
      setTeams([]);
      setBooks([]);
      setRule({});
      setNotifications({});
    }
  }, [inEditMode]);

  // Scroll to top when formState changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [formState]);

  // Verify user has an active subscription
  useEffect(() => {
    const redirectPath = AccessVerification();
    if (redirectPath) {
      navigate(redirectPath);
    }
  }, [navigate]);

  // Enforce 5-rule limit for Basic plan users (create mode only)
  useEffect(() => {
    if (inEditMode) return;
    const subscriptionName = localStorage.getItem("subscription_name") || "";
    if (!subscriptionName.toLowerCase().includes("basic")) return;
    ApiCall.makeAuthenticatedRequest("/api/load_rules/").then(
      (response: Record<string, unknown>) => {
        if (!("error" in response)) {
          const rulesData = response["rules"] as unknown[];
          if (rulesData && rulesData.length >= 5) {
            setIsAtLimit(true);
          }
        }
      },
    );
  }, [inEditMode]);

  const clearData = (limited: boolean = false) => {
    if (!limited) {
      setRuleName("");
      setSportSelectionId(-1);
    }
    setTeams([]);
    setBooks([]);
    setRule({});
    setNotifications({});
  };

  const updateSport = (newState: number) => {
    if (newState !== sportSelectionId) {
      clearData(true);
      setSportSelectionId(newState);
    }
  };

  const updateRuleType = (newType: number) => {
    if (newType !== ruleTypeId) {
      clearData(true);
      setRuleTypeId(newType);
    }
  };

  if (isSportsLoading) {
    return (
      <div>
        <PageNav />
        <div className="main_div">
          <div className="center_me" style={{ padding: 40 }}>
            <p className="font_family_base">Loading...</p>
          </div>
        </div>
        <Footer />
      </div>
      // <div
      //   style={{
      //     display: "flex",
      //     justifyContent: "center",
      //     alignItems: "center",
      //     minHeight: "100vh",
      //   }}
      // >
      //   <div>Loading...</div>
      // </div>
    );
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <PageNav />
      <div className="center_me" style={{ flex: 1 }}>
        <div className="main_div" style={{ maxWidth: 800 }}>
          {isAtLimit && (
            <div
              className="font_family_base"
              style={{
                backgroundColor: "#2a1a00",
                border: "1px solid #f59e0b",
                borderRadius: 8,
                padding: "12px 16px",
                marginBottom: 16,
                color: "#f59e0b",
                textAlign: "center",
                fontSize: 14,
              }}
            >
              You've reached the 5-rule limit for the Basic plan. Upgrade to Pro
              for unlimited rules.
            </div>
          )}
          <div
            style={
              isAtLimit ? { pointerEvents: "none", opacity: 0.4 } : undefined
            }
          >
            {(isSportsLoading || Object.keys(sportsMetadata).length === 0) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 20,
                }}
              >
                <div className="font_family_base detail_text">Loading...</div>
              </div>
            )}
            {!isSportsLoading &&
            Object.keys(sportsMetadata).length > 0 &&
            !sportsError &&
            sportsMetadata &&
            (sportsMetadata as Record<string, unknown>)["sports_metadata"] ? (
              <>
                {1 === formState && (
                  <>
                    <WatcherFormStep>
                      <WatcherFormNameAndSport
                        key="form_part_1"
                        sportsMetadata={sportsMetadata}
                        formState={formState}
                        setFormState={setFormState}
                        ruleName={ruleName}
                        setRuleName={setRuleName}
                        setSportSelection={updateSport}
                        sportSelectionId={sportSelectionId}
                        ruleType={ruleTypeId}
                        setRuleType={updateRuleType}
                        inEditMode={inEditMode}
                      ></WatcherFormNameAndSport>
                    </WatcherFormStep>
                  </>
                )}
                {ruleTypeId !== 1 && <div></div>}
                {2 === formState && (
                  <WatcherFormStep>
                    <CheckboxTree
                      key="form_part_2"
                      sportsMetadata={
                        (
                          (
                            sportsMetadata["sports_metadata"] as Record<
                              string,
                              unknown
                            >
                          )[sportSelectionId] as Record<string, unknown>
                        )["conferences"] as Record<string, unknown>
                      }
                      formState={formState}
                      setFormState={setFormState}
                      teams={Object.fromEntries(
                        Array.from(teams).map((key) => [key, true]),
                      )}
                      setTeams={setTeams}
                      ruleType={ruleTypeId}
                      playerMetadata={
                        (sportsMetadata["player_metadata"] as Record<
                          string,
                          unknown
                        >) ?? {}
                      }
                    ></CheckboxTree>
                  </WatcherFormStep>
                )}
                {3 === formState && (
                  <WatcherFormStep>
                    <WatcherFormSportbooks
                      key="form_part_3"
                      sportbooksMetadata={
                        (sportsMetadata as Record<string, unknown>)[
                          "betting_houses"
                        ] as unknown as Record<
                          string,
                          { id: string; name: string }
                        >
                      }
                      formState={formState}
                      setFormState={setFormState}
                      books={books}
                      setBooks={setBooks}
                    ></WatcherFormSportbooks>
                  </WatcherFormStep>
                )}
                {4 === formState && (
                  <WatcherFormStep>
                    <WatcherFormRule
                      key={"form_part_4"}
                      formState={formState}
                      setFormState={setFormState}
                      rule={rule}
                      setRule={setRule}
                      gamePartName={
                        (
                          (
                            sportsMetadata["sports_metadata"] as Record<
                              string,
                              unknown
                            >
                          )[sportSelectionId] as Record<string, unknown>
                        )["game_part_name"] as string
                      }
                      gamePartCount={
                        (
                          (
                            sportsMetadata["sports_metadata"] as Record<
                              string,
                              unknown
                            >
                          )[sportSelectionId] as Record<string, unknown>
                        )["game_part_count"] as number
                      }
                      ruleTypeId={ruleTypeId}
                      sportId={parseInt(
                        String(
                          (
                            (
                              sportsMetadata["sports_metadata"] as Record<
                                string,
                                unknown
                              >
                            )[sportSelectionId] as Record<string, unknown>
                          )?.["id"] ?? "",
                        ).replace(/\D/g, ""),
                        10,
                      )}
                      ruleDefinitions={
                        (sportsMetadata["rule_definitions"] as Record<
                          string,
                          unknown
                        >) ?? {}
                      }
                      ruleGroups={
                        (sportsMetadata["rule_groups"] as Record<
                          string,
                          unknown
                        >) ?? {}
                      }
                      inEditMode={inEditMode}
                    ></WatcherFormRule>
                  </WatcherFormStep>
                )}
                {5 === formState && (
                  <WatcherFormStep>
                    <WatcherFormNotifications
                      key="form_part_5"
                      formState={formState}
                      sport={
                        (
                          (
                            sportsMetadata["sports_metadata"] as Record<
                              string,
                              unknown
                            >
                          )[sportSelectionId] as Record<string, unknown>
                        )["name"] as string
                      }
                      sportId={
                        (
                          (
                            sportsMetadata["sports_metadata"] as Record<
                              string,
                              unknown
                            >
                          )[sportSelectionId] as Record<string, unknown>
                        )["id"] as number
                      }
                      name={ruleName}
                      teams={teams}
                      books={books}
                      rule={rule}
                      setFormState={setFormState}
                      notifications={notifications}
                      setNotifications={setNotifications}
                      isUpdate={inEditMode}
                      ruleId={parseInt(rule_id)}
                      ruleType={ruleTypeId}
                    ></WatcherFormNotifications>
                  </WatcherFormStep>
                )}
                {6 === formState && (
                  <WatcherFormStep>
                    <WatcherFormSubmitted
                      key="form_part_6"
                      setFormState={setFormState}
                      clearData={clearData}
                      isEditMode={inEditMode}
                    ></WatcherFormSubmitted>
                  </WatcherFormStep>
                )}
              </>
            ) : null}
            {(sportsError || ruleError) && (
              <p className="error font_family_base">
                <span>⛔️</span> {sportsError}
              </p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
